const local = {
  yearSuffix: '',
  monthsHead: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  months: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dev".split("_"),
  weeks: "Dom_Seg_Ter_Qua_Qui_Sex_Sab".split("_"),
  cancelTip: "CANCELAR",
  submitTip: "CONFIRMAR"
};

export default local


// WEBPACK FOOTER //
// ./src/Utils/VueDatepickerLocal.js